(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tms-signup-steps"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'tmsSignupStepsV1';
  if (window[key]) return;
  window[key] = true;
  const seenRoots = new WeakSet();
  const seenForms = new WeakSet();
  const roots = new Set([document]);
  const css = `
    [data-tms-signup] [data-tms-hidden] { display: none !important; }
    [data-tms-signup] fieldset { border: 0; padding: 0; margin: 8px 0 12px; min-width: 0; }
    [data-tms-signup] fieldset legend { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }
    [data-tms-signup] fieldset > div { display: grid; gap: 9px; }
    [data-tms-signup] fieldset label { position: relative; display: flex; justify-content: center; align-items: center; box-sizing: border-box; min-height: 49px; width: 100%; margin: 0; padding: 12px 16px; border: 1px solid #655b54; border-radius: 3px; background: #17171a; color: #f2efec; cursor: pointer; transition: background 160ms, border-color 160ms, color 160ms; }
    [data-tms-signup] fieldset label:hover { background: #29211e; border-color: #df7647; }
    [data-tms-signup] fieldset label:has(input:checked) { background: #df7647; border-color: #df7647; color: #141013; }
    [data-tms-signup] fieldset label span { color: inherit !important; font: inherit; }
    [data-tms-signup] fieldset input[type=radio] { position: absolute; width: 1px; height: 1px; opacity: 0; margin: 0; }
    [data-tms-signup] fieldset label:has(input:focus-visible) { outline: 2px solid #f2efec; outline-offset: 3px; }
    [data-tms-signup] [data-testid=btn-form-submit] { box-sizing: border-box; border-radius: 3px; height: 49px; min-height: 49px; padding: 12px 16px; display: flex; justify-content: center; align-items: center; }
    [data-tms-signup] .tms-step-back { border: 0; padding: 7px; background: transparent; color: #f2efec; font: inherit; text-decoration: underline; text-underline-offset: 4px; cursor: pointer; }
    [data-tms-signup] .tms-step-error { color: #ffb4a2; margin: 0; font-size: 13px; }
    [data-tms-signup][data-tms-step=phone] form { margin-top: 20px; }
    @media (prefers-reduced-motion: no-preference) { [data-tms-signup][data-tms-step=phone] form { animation: tms-step-enter 220ms ease-out; } @keyframes tms-step-enter { from { opacity: .3; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } } }
    @media (max-width: 480px) { [data-tms-signup] fieldset label { min-height: 46px; padding: 10px 14px; } }
  `;
  function enhance(form, root) {
    if (seenForms.has(form)) return;
    const stage = form.querySelector('fieldset[name="custom#hair-loss_stage"]');
    const email = form.querySelector('[data-testid="field-email"]');
    const phone = form.querySelector('[data-testid="field-phone_number"]');
    const submit = form.querySelector('[data-testid="btn-form-submit"]');
    const panel = form.closest('[role="dialog"][aria-label]');
    const heading = panel?.querySelector('h2');
    const intro = heading?.nextElementSibling;
    if (!stage || !email || !phone || !submit || !panel || !heading || !intro) return;
    const emailWrap = email.parentElement;
    const phoneWrap = phone.parentElement.parentElement;
    if (!form.contains(phoneWrap) || phoneWrap === form) return;
    seenForms.add(form);
    if (!root.querySelector('style[data-tms-step-style]')) {
      const style = document.createElement('style');
      style.dataset.tmsStepStyle = '';
      style.textContent = css;
      (root === document ? document.head : root).append(style);
    }
    const originalTitle = heading.textContent;
    const error = document.createElement('p');
    error.className = 'tms-step-error';
    error.setAttribute('role', 'alert');
    error.id = 'tms-signup-email-error';
    error.hidden = true;
    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'tms-step-back';
    back.textContent = 'Back';
    back.setAttribute('data-tms-hidden', '');
    form.insertBefore(error, emailWrap.nextSibling);
    form.append(back);
    let step = 'email';
    panel.setAttribute('data-tms-signup', '');
    panel.setAttribute('data-tms-step', step);
    phoneWrap.setAttribute('data-tms-hidden', '');
    intro.textContent = 'Join the Mane Memo.';
    function show(next, focus = true) {
      step = next;
      const isPhone = next === 'phone';
      panel.setAttribute('data-tms-step', next);
      stage.toggleAttribute('data-tms-hidden', isPhone);
      emailWrap.toggleAttribute('data-tms-hidden', isPhone);
      phoneWrap.toggleAttribute('data-tms-hidden', !isPhone);
      back.toggleAttribute('data-tms-hidden', !isPhone);
      heading.textContent = isPhone ? 'Just to lock it in' : originalTitle;
      intro.textContent = isPhone ? 'Add your phone number. This is optional.' : 'Join the Mane Memo.';
      panel.setAttribute('aria-label', heading.textContent);
      if (focus) (isPhone ? phone : email).focus();
    }
    function advance(event) {
      if (step !== 'email') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
      if (!valid) {
        error.textContent = 'Enter a valid email address.';
        error.hidden = false;
        email.setAttribute('aria-describedby', error.id);
        email.focus();
        return;
      }
      error.hidden = true;
      email.removeAttribute('aria-describedby');
      show('phone');
    }
    submit.addEventListener('click', advance, true);
    form.addEventListener('submit', advance, true);
    back.addEventListener('click', () => show('email'));
    email.addEventListener('input', () => { error.hidden = true; });
    const observeErrors = new MutationObserver(() => {
      if (!form.isConnected) { observeErrors.disconnect(); return; }
      if (step === 'phone' && email.getAttribute('aria-invalid') === 'true') show('email');
    });
    observeErrors.observe(email, { attributes: true, attributeFilter: ['aria-invalid'] });
  }
  let queued = false;
  function scan() {
    queued = false;
    for (const root of roots) {
      if (root.host && !root.host.isConnected) { roots.delete(root); continue; }
      if (!seenRoots.has(root)) {
        seenRoots.add(root);
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
      root.querySelectorAll('form').forEach(form => enhance(form, root));
      root.querySelectorAll('*').forEach(element => {
        if (element.shadowRoot && !element.id.startsWith('codex-')) roots.add(element.shadowRoot);
      });
    }
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  }
  scan();
  let attempts = 0;
  const timer = setInterval(() => {
    schedule();
    if (++attempts >= 60) clearInterval(timer);
  }, 1000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tms-subscription-caption"] && !Shopify.designMode) return;
  try {
    (() => {
  const copy = document.getElementById('TmsSubscriptionCopy');
  const main = document.getElementById('MainContent');
  if (!copy || !main) return;
  let queued = false;
  function sync() {
    queued = false;
    main.querySelectorAll('.kaching-bundles__subscriptions__card').forEach(card => {
      const caption = card.querySelector('.kaching-bundles__subscriptions__subtitle');
      if (!caption) return;
      const title = card.querySelector('.kaching-bundles__subscriptions__title');
      if (title && title.textContent.trim() !== copy.dataset.title) title.textContent = copy.dataset.title;
      const select = card.querySelector('.kaching-bundles__selling-plan-select');
      if (select) Array.from(select.options).forEach(option => {
        const concise = option.textContent.trim().replace(/^Deliver\s+Every\s+/i, 'Every ');
        if (option.textContent.trim() !== concise) option.textContent = concise;
      });
      const text = select?.selectedOptions[0]?.textContent.trim() || copy.dataset.choose;
      if (caption.textContent.trim() !== text) caption.textContent = text;
      if (select && select.getAttribute('aria-label') !== copy.dataset.label) {
        select.setAttribute('aria-label', copy.dataset.label);
      }
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(sync); }
  }
  main.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true, characterData: true });
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
